module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"delete":"Удалить","hide":"Скрыть","show":"Показать","edit":"Переименовать"}}')
  delete Component.options._Ctor
}
